import React from 'react';
import type { EditContext, AnyItem, FormConfig, Image, ItemWithId, StoreState } from '../../types/types';
import TypedEditModal from './TypedEditModal';

interface EditModalProps {
  context: EditContext<AnyItem>;
  isOpen: boolean;
  onClose: () => void;
  formConfig: FormConfig;
  getState: () => StoreState;
  imageLibrary: Image[];
  showImageSelectModal: (cb: (id: number) => void) => void;
  onViewOnMap: (item: ItemWithId | null, itemType: string | null) => void;
  onHealToFull: (item: ItemWithId | null) => void;
}

/**
 * Presenter component for EditModal (ADR-034).
 *
 * Resolves the entity-specific form config from the type key and delegates
 * rendering to TypedEditModal. All store-derived data and callbacks are
 * received as props from EditModalContainer.
 */
const EditModal = ({
  context,
  isOpen,
  onClose,
  formConfig,
  getState,
  imageLibrary,
  showImageSelectModal,
  onViewOnMap,
  onHealToFull,
}: EditModalProps) => {
  const { type } = context;
  const config = formConfig[type] as FormConfig[keyof FormConfig];

  return (
    <TypedEditModal
      config={config}
      context={context as EditContext<AnyItem>}
      isOpen={isOpen}
      onClose={onClose}
      getState={getState}
      imageLibrary={imageLibrary}
      showImageSelectModal={showImageSelectModal}
      onViewOnMap={onViewOnMap}
      onHealToFull={onHealToFull}
    />
  );
};

export default EditModal;
